//react imports
import { Link } from "react-router-dom";
//firebase imports
import { getAuth } from "firebase/auth";
import { collection, query, where, getDocs, getFirestore } from "firebase/firestore";






const auth = getAuth();
const db = getFirestore();


const HomeLoggedIn = () => {


    return (
        <div className="container-btn">
            <div className="btn-primary-box">
                <Link to={`/insertExpense/${null}/${null}`}><button className="btn-primary">Insert Expenses</button></Link>
            </div>
            <div className="btn-secondary-box">
                <button onClick={goToLastVisited} className="btn-secondary">Watch Last Expenses</button>
                <p className="errorMessage noLastVisitedGroup"></p>
            </div>
        </div>
    );

    async function goToLastVisited() {
        let lastGroup = null;
        try {
            if (auth.currentUser !== null) {
                const userDocs = query(collection(db, "Users"), where('userId', '==', auth.currentUser.uid));
                const userDocsSnapshot = await getDocs(userDocs);

                userDocsSnapshot.forEach(doc => {
                    lastGroup = doc.data().lastVisitedGroup;
                });
            }
            if (lastGroup != null) {
                window.location.href = `/expenses/${lastGroup}`;
            }
            else {
                document.getElementsByClassName('noLastVisitedGroup')[0].innerHTML = "You haven't visited any groups yet.";
            }
        } catch (error) {
            document.getElementsByClassName('noLastVisitedGroup')[0].innerHTML = "Something went wrong:" + error;
        }
    }
};

export default HomeLoggedIn;